import { createContext } from 'react';

/**
 * What `PeopleAccessLayout` shares with the screens inside it: where the app is mounted and a way
 * for a list page to take over the header (so the title and tabs sit in the page's own sticky band
 * and compress with it). Without a provider the defaults keep a stray render harmless.
 */
export const PeopleAccessHeaderContext = createContext({ basePath: '', claimHeader: () => () => {} });
